import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import DeleteReport from '../../containers/reports/DeleteReport'

class PReportDelete extends React.Component<RouteComponentProps<{  customerId: string, id: string, name: string}>> {
    render() {
        const { customerId,  id , name} = this.props.match.params
        const back = `/admin/customers/${customerId}`
        return (
            <React.Fragment>
                <DeleteReport
                    customerId={customerId}
                    id={+id}
                    name={name}
                    back={back}
                    onSuccess={() => this.props.history.push(back)}
                />
            </React.Fragment>
        )
    }
}

export default PReportDelete
